import Icon from "../../../../../assets/icons";
import primaryComponents from "../../../../../components/primaryComponents";
import styles from "./styles.module.scss";
import { truncateString } from "../../../../../helpers";

const TableCard = ({
  table,
  updateOrderTable = () => {},
  isUpdatingOrderTable,
}) => {
  return (
    <div
      className={`${styles.card} ${
        table?.status === "FREE" ? styles.card_green : styles.card_red
      }`}
    >
      <div className={styles.title_diners_conatiner}>
        <div className={styles.title_container}>
          <p className={"failed--text mb-0"} style={{ padding: "2px 10px" }}>
            {truncateString(table?.name, 25)}
          </p>

          <div className={styles.seats_container}>
            <h6 className="white--text mb-0">{table?.seat_capacity} seats</h6>
          </div>
        </div>
        <div className={styles.diners_container}>
          <div className={styles.diner_icon}>
            <img
              src={
                table?.status === "FREE"
                  ? Icon.dinersIconGreen
                  : Icon.dinersIcon
              }
              alt="diners"
            />
          </div>
          <h6 className="purple--text mb-0">{table?.diners} diners</h6>
        </div>
      </div>
      <primaryComponents.Button
        type="button"
        classNames={`btn smallBtn ${
          table?.status === "FREE" ? "btn--outline-green" : "btn--outline-red"
        }`}
        onClick={() => updateOrderTable(table?.id)}
        disabled={isUpdatingOrderTable}
        isLoading={isUpdatingOrderTable}
      >
        Select Table
      </primaryComponents.Button>
    </div>
  );
};

export default TableCard;
